import React, { PureComponent } from 'react';
import Loader from '4all-ui/components/Loader';
import * as styles from './style';
import * as GenericStyles from '../../styles/StyledComponents/GenericList';
import GenericListHeader from '../GenericListHeader';
import Accordion from './Accordion';
import { filterVariationOptions } from '../../helpers/search';

class GenericList extends PureComponent {
  state = {
    searchText: '',
  };

  handleChange = e => this.setState({ searchText: e.target.value });

  filterOptions = () => {
    const { options } = this.props;
    const { searchText } = this.state;

    return filterVariationOptions(searchText, options);
  };

  handleClear = () => {
    this.setState({ searchText: '' });
  };

  render() {
    const filteredOptions = this.filterOptions().map(option => ({
      ...option,
      isFiltering: this.state.searchText.length > 0,
    }));
    const {
      id,
      CustomItem,
      title,
      desc,
      searchPlaceholder,
      toggleParentItem,
      toggleItem,
      saleType,
      customListStyles,
      headerStyles,
      options,
      isLoading,
      search,
    } = this.props;

    return (
      <GenericStyles.Container>
        <styles.Header customStyles={!options.length || isLoading ? headerStyles : ''}>
          <GenericListHeader
            id={`${id}-search`}
            title={title}
            desc={desc}
            onChange={this.handleChange}
            searchText={this.state.searchText}
            search={search}
            searchPlaceholder={searchPlaceholder || 'Pesquise'}
            onClear={this.handleClear}
            searchInputSize="100%"
          />
        </styles.Header>

        {isLoading ? (
          <GenericStyles.LoaderContainer className="loading-products">
            <Loader size="60px" />
          </GenericStyles.LoaderContainer>
        ) : (
          <styles.List customListStyles={customListStyles}>
            {filteredOptions.map((item, index) => (
              <Accordion
                key={item.id}
                data={item}
                CustomItem={CustomItem}
                toggleParentItem={toggleParentItem}
                toggleItem={toggleItem}
                saleType={saleType}
                lastItem={index === filteredOptions.length - 1}
                isFiltering={item.isFiltering}
              />
            ))}

            {!isLoading && !filteredOptions.length && (
              <styles.StyledEmptyMessage big as="li">
                Nenhum registro encontrado
              </styles.StyledEmptyMessage>
            )}
          </styles.List>
        )}
      </GenericStyles.Container>
    );
  }
}

export default GenericList;



// WEBPACK FOOTER //
// ./src/components/GenericList/index.js